import React, { useRef } from "react";
import { connect, ConnectedProps } from "react-redux";
import { openTooltip } from "../../../../store/actions";
import { isTouchScreen } from "../../../../lib/elementUtilities";

interface IProps {
  icon: string;
  title: string;
  content: string;
  value?: string | number;
  className?: string;
}

const mapDispatchToProps = (dispatch: any) => ({
  openTooltipDispatch: (tooltipOptions: any) => dispatch(openTooltip(tooltipOptions))
});

const connector = connect(null, mapDispatchToProps);

const AttributeIcon = ({
  icon,
  title,
  content,
  value,
  className,
  openTooltipDispatch
}: IProps & ConnectedProps<typeof connector>) => {
  const iconRef = useRef<HTMLDivElement>(null);

  return (
    <span
      ref={iconRef}
      onMouseEnter={() => !isTouchScreen() && openTooltipDispatch({
        static: true,
        title,
        content,
        elementRef: iconRef
      })}
      onMouseOver={() => !isTouchScreen() && openTooltipDispatch({
        static: true,
        title,
        content,
        elementRef: iconRef
      })}
      onClick={() => isTouchScreen() && openTooltipDispatch({
        static: true,
        title,
        content,
        elementRef: iconRef
      })}
    >
      <i className={`icon icon-${icon} icon ${className}`} />
      {value !== undefined ? <><br />{value}</> : null}
    </span>
  )
}

export default connector(AttributeIcon);
